export var CommonSchemaIds;
(function (CommonSchemaIds) {
    CommonSchemaIds["RANGE"] = "range";
})(CommonSchemaIds || (CommonSchemaIds = {}));
